import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToasterData, TosterMsgType } from './model';
import { ConstantData } from './constants';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  // Toaster Observable that will consumed by toaster component 
  private toasterObs = new BehaviorSubject<ToasterData>({msg:'', type:TosterMsgType.ERROR,isHide:true});
  toasterState = this.toasterObs.asObservable();

  // variable that will have to settimeout reference  
  private toadterTimer:any;

  // store the constant data
  private constantData = ConstantData;



  constructor() { }



  /**
   * Method to show the toast message
   * @param msg - string - Message the you want to show
   * @param type - TosterMsgType - enum that can have ERROR/SUCCESS/WARNING type.
   * @param timer - number - time in miliseconds 
   */
  showMsg(msg:string, type:TosterMsgType, timer?:number, callBack?:any, isTimer:boolean = true){
    if(this.toadterTimer){
      clearTimeout(this.toadterTimer);
    }
    this.toasterObs.next({msg:msg, type:type,isHide:false, callBack});

    if(isTimer){
      this.toadterTimer = setTimeout(()=>{
        this.toasterObs.next({msg:msg, type:type,isHide:true});
      },timer || this.constantData.toasterMsgTime);
    }

  }



  /**
   * Method to hide the toast message
   */
  hide(){
    if(this.toadterTimer){
      clearTimeout(this.toadterTimer);
    }
    this.toasterObs.next({msg:'', type:TosterMsgType.ERROR,isHide:true});
  }
}
